import React, { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";

// Compact countdown "3g 14h 08m 22s" — mono font
export default function Countdown({ endsAt, className = "", short = false }) {
  const { language, t } = useLanguage();
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const end = new Date(endsAt).getTime();
  let diff = Math.max(0, end - now);
  const days = Math.floor(diff / 86400000); diff -= days * 86400000;
  const hours = Math.floor(diff / 3600000); diff -= hours * 3600000;
  const mins = Math.floor(diff / 60000); diff -= mins * 60000;
  const secs = Math.floor(diff / 1000);
  const ending = end - now < 3600000 * 6 && end - now > 0;
  const done = end - now <= 0;
  if (done) return <span data-testid="countdown-ended" className={`font-mono ${className}`}>{t("Terminata")}</span>;
  const pad = (n) => String(n).padStart(2, "0");
  return (
    <span
      data-testid="countdown"
      className={`font-mono ${ending ? "text-[#8C3A3A] pulse-red" : "text-stone-900"} ${className}`}
    >
      {short
        ? `${days > 0 ? days + (language === "en" ? "d " : "g ") : ""}${pad(hours)}:${pad(mins)}:${pad(secs)}`
        : `${days}${language === "en" ? "d" : "g"} ${pad(hours)}h ${pad(mins)}m ${pad(secs)}s`}
    </span>
  );
}
